export const FETCH_WEIGHT_DISPUTE_IMAGE_SUCCESS = "FETCH_WEIGHT_DISPUTE_IMAGE_SUCCESS";
export const FETCH_WEIGHT_DISPUTE_IMAGE_REQUEST = "FETCH_WEIGHT_DISPUTE_IMAGE_REQUEST";
export const FETCH_WEIGHT_DISPUTE_IMAGE_FAILURE = "FETCH_WEIGHT_DISPUTE_IMAGE_FAILURE";
export const FETCH_WEIGHT_DISPUTE_IMAGE_RESET = "FETCH_WEIGHT_DISPUTE_IMAGE_RESET";
export const fetchWeightDisputeImageSuccess = (payload) => ({
    type: FETCH_WEIGHT_DISPUTE_IMAGE_SUCCESS,
    payload,
});
export const fetchWeightDisputeImageRequest = (payload) => ({
    type: FETCH_WEIGHT_DISPUTE_IMAGE_REQUEST,
    payload,
});
export const fetchWeightDisputeImageFailure = (payload) => ({
    type: FETCH_WEIGHT_DISPUTE_IMAGE_FAILURE,
    payload,
});
export const fetchWeightDisputeImageReset = () => ({
    type: FETCH_WEIGHT_DISPUTE_IMAGE_RESET,
});
